import {createGetHook} from "services/http/hooks";
import {Brand} from "../../../types/brand";

// Static GET: Brands
export const useGetBrandsQuery = createGetHook<Brand[]>("/brands");
